import {createMemoryHistory, createRouter} from 'vue-router';

import {routes} from '@/routes';

import {FAQ} from '@/screens';
import {SignIn} from '@/screens';
import {SignUp} from '@/screens';
import {Limits} from '@/screens';
import {Profile} from '@/screens';
import {Payments} from '@/screens';
import {CardMenu} from '@/screens';
import {Statistics} from '@/screens';
import {Onboarding} from '@/screens';
import {NewPassword} from '@/screens';
import {OpenDeposit} from '@/screens';
import {CardDetails} from '@/screens';
import {OpenNewCard} from '@/screens';
import {IBANPayment} from '@/screens';
import {OpenNewLoan} from '@/screens';
import {InvoiceSent} from '@/screens';
import {OpenMoneybox} from '@/screens';
import {TopUpPayment} from '@/screens';
import {FundTransfer} from '@/screens';
import {PrivacyPolicy} from '@/screens';
import {PaymentFailed} from '@/screens';
import {CreateInvoice} from '@/screens';
import {MobilePayment} from '@/screens';
import {ChangePINCode} from '@/screens';
import {PaymentSuccess} from '@/screens';
import {ForgotPassword} from '@/screens';
import {SelectLanguage} from '@/screens';
import {EditPersonalInfo} from '@/screens';
import {ConfirmationCode} from '@/screens';
import {TransactionDetails} from '@/screens';
import {SignUpAccountCreated} from '@/screens';
import {VerifyYourPhoneNumber} from '@/screens';
import {ForgotPasswordSentEmail} from '@/screens';

import {TabNavigator} from '@/screens';

const stack = [
  {
    path: routes.FAQ,
    name: routes.FAQ,
    component: FAQ,
  },
  {
    path: routes.LIMITS,
    name: routes.LIMITS,
    component: Limits,
  },
  {
    path: routes.SIGN_IN,
    name: routes.SIGN_IN,
    component: SignIn,
  },
  {
    path: routes.SIGN_UP,
    name: routes.SIGN_UP,
    component: SignUp,
  },
  {
    path: routes.PROFILE,
    name: routes.PROFILE,
    component: Profile,
  },
  {
    path: routes.PAYMENTS,
    name: routes.PAYMENTS,
    component: Payments,
  },
  {
    path: routes.CARD_MENU,
    name: routes.CARD_MENU,
    component: CardMenu,
  },
  {
    path: routes.STATISTICS,
    name: routes.STATISTICS,
    component: Statistics,
  },
  {
    path: routes.OPEN_NEW_LOAN,
    name: routes.OPEN_NEW_LOAN,
    component: OpenNewLoan,
  },
  {
    path: routes.OPEN_MONEYBOX,
    name: routes.OPEN_MONEYBOX,
    component: OpenMoneybox,
  },
  {
    path: routes.OPEN_DEPOSIT,
    name: routes.OPEN_DEPOSIT,
    component: OpenDeposit,
  },
  {
    path: routes.SELECT_LANGUAGE,
    name: routes.SELECT_LANGUAGE,
    component: SelectLanguage,
  },
  {
    path: routes.ONBOARDING,
    name: routes.ONBOARDING,
    component: Onboarding,
  },
  {
    path: routes.IBAN_PAYMENT,
    name: routes.IBAN_PAYMENT,
    component: IBANPayment,
  },
  {
    path: routes.NEW_PASSWORD,
    name: routes.NEW_PASSWORD,
    component: NewPassword,
  },
  {
    path: routes.CARD_DETAILS,
    name: routes.CARD_DETAILS,
    component: CardDetails,
  },
  {
    path: routes.OPEN_NEW_CARD,
    name: routes.OPEN_NEW_CARD,
    component: OpenNewCard,
  },
  {
    path: routes.TAB_NAVIGATOR,
    name: routes.TAB_NAVIGATOR,
    component: TabNavigator,
  },
  {
    path: routes.FUND_TRANSFER,
    name: routes.FUND_TRANSFER,
    component: FundTransfer,
  },
  {
    path: routes.TOP_UP_PAYMENT,
    name: routes.TOP_UP_PAYMENT,
    component: TopUpPayment,
  },
  {
    path: routes.MOBILE_PAYMENT,
    name: routes.MOBILE_PAYMENT,
    component: MobilePayment,
  },
  {
    path: routes.PRIVACY_POLICY,
    name: routes.PRIVACY_POLICY,
    component: PrivacyPolicy,
  },
  {
    path: routes.PAYMENT_FAILED,
    name: routes.PAYMENT_FAILED,
    component: PaymentFailed,
  },
  {
    path: routes.CREATE_INVOICE,
    name: routes.CREATE_INVOICE,
    component: CreateInvoice,
  },
  {
    path: routes.CHANGE_PIN_CODE,
    name: routes.CHANGE_PIN_CODE,
    component: ChangePINCode,
  },
  {
    path: routes.FORGOT_PASSWORD,
    name: routes.FORGOT_PASSWORD,
    component: ForgotPassword,
  },
  {
    path: routes.PAYMENT_SUCCESS,
    name: routes.PAYMENT_SUCCESS,
    component: PaymentSuccess,
  },
  {
    path: routes.EDIT_PERSONAL_INFO,
    name: routes.EDIT_PERSONAL_INFO,
    component: EditPersonalInfo,
  },
  {
    path: routes.TRANSACTION_DETAILS,
    name: routes.TRANSACTION_DETAILS,
    component: TransactionDetails,
  },
  {
    path: routes.SIGN_UP_ACCOUNT_CREATED,
    name: routes.SIGN_UP_ACCOUNT_CREATED,
    component: SignUpAccountCreated,
  },
  {
    path: routes.FORGOT_PASSWORD_SENT_EMAIL,
    name: routes.FORGOT_PASSWORD_SENT_EMAIL,
    component: ForgotPasswordSentEmail,
  },
  {
    path: routes.VERIFY_YOUR_PHONE_NUMBER,
    name: routes.VERIFY_YOUR_PHONE_NUMBER,
    component: VerifyYourPhoneNumber,
  },
  {
    path: routes.CONFIRMATION_CODE,
    name: routes.CONFIRMATION_CODE,
    component: ConfirmationCode,
  },
  {
    path: routes.INVOICE_SENT,
    name: routes.INVOICE_SENT,
    component: InvoiceSent,
  },
];

const router = createRouter({
  history: createMemoryHistory(),
  routes: stack,
});

export default router;
